import { IAppUser, IAppUserWithStats } from '../../../interfaces';
import privateHttpClient from '../privateHttpClient';
import AppUserMapper from '../mappers/AppUserMapper';
import { urlHttpGov } from '../../urls';
import AppUserWithStatsMapper from '../mappers/AppUserWithStatsMapper';
import { TypeSortAppUser } from '../../../pages/AppUsers/useAppUsers';

interface IPropsListAppUsersWithPaginate {
    cityId: number,
    page: number,
    size: number,
    sort?: TypeSortAppUser,
    order?: 'asc' | 'desc',
    name?: string,
    cpf?: string,
    phone?: string,
    createdAt?: string,
    signal: AbortSignal
}
class AppUsersService {
    private baseURL: string = `${urlHttpGov}/panel/app_user`;

    async listAppUsers({ cityId, signal }: { cityId: number, signal: AbortSignal }) {

        const { data } = await privateHttpClient.get(`${this.baseURL}/county/${cityId}`, { signal });

        return data.map((user: any) => AppUserMapper.toDomain(user));
    }

    async exportAppUsers({ cityId, type, signal }: { cityId: number; type: "excel" | "pdf"; signal?: AbortSignal; }) {
        const { data, headers } = await privateHttpClient.get(
            `${this.baseURL}/county/${cityId}/export`, {
            params: {
                type,
            },
            responseType: "blob",
            signal,
        },
        );

        const contentDisposition = headers["content-disposition"];

        let filename = type === "excel" ? "usuarios.xlsx" : "usuarios.pdf";

        if (contentDisposition) {
            const match = contentDisposition.match(
                /filename="?([^"]+)"?/,
            );

            if (match?.[1]) {
                filename = match[1];
            }
        }

        return {
            blob: data,
            filename,
        };
    }


    async listAppUsersWithPaginate({ cityId, page, size, sort, order, name, cpf, phone, createdAt, signal }: IPropsListAppUsersWithPaginate): Promise<{ appUsers: IAppUserWithStats[], total: number }> {

        const params: Record<string, any> = {
            page,
            size,
            sort,
            order,
            name,
            cpf,
            phone,
            createdAt
        };

        Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);

        const queryString = new URLSearchParams(params).toString();
        const url = `${this.baseURL}/county/${cityId}/paginate?${queryString}`;

        const { data } = await privateHttpClient.get(url, { signal });

        return {
            appUsers: data.app_users.map((user: any) => AppUserWithStatsMapper.toDomain(user)),
            total: data.total
        };
    }


    createAppUser(appUser: IAppUser) {
        const persistenceAppUser = AppUserMapper.toPersistence(appUser);

        return privateHttpClient.post(this.baseURL, persistenceAppUser);
    }

    async getAppUserById({ appUserId, signal }: { appUserId: number, signal: AbortSignal }) {
        const { data } = await privateHttpClient.get(`${this.baseURL}/${appUserId}`, { signal });

        return AppUserMapper.toDomain(data);
    }

    updateAppUser({ appUserId, appUser }: { appUserId: number, appUser: IAppUser }) {
        const persistenceAppUser = AppUserMapper.toPersistence(appUser);

        return privateHttpClient.patch(`${this.baseURL}/${appUserId}`, persistenceAppUser);
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AppUsersService();
